<template>
  <div class="aianswer-wrapper">
    <LoadingComponent v-show="pageLoading"></LoadingComponent>
    <div class="answer" v-if="list.length" v-show="!showGuide">
      <div class="top">
        <div class="item">{{ index + 1 }}/{{ list.length }}</div>
        <div class="item">{{ countdownText }}</div>
      </div>
        <div class="swiper swiper-no-swiping">
            <div class="swiper-wrapper">
                <div class="swiper-slide" :style="`padding-top: 22vw;`" v-for="item in list" :key="item">
                    <img class="answer-option-img" :src="item.file" alt="" v-if="item.file">
                    <div class="title">
                      【{{ typeText[item.type] }}】{{ item.title }}
                      <span :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" v-if="isViewNews && item.info && item.info.news_id" @click="handleViewNews(item.info)">
                        <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4437" width="1024" height="1024"><path d="M306.05312 361.6768a61.44 61.44 0 0 1 4.21888 82.20672l-4.21888 4.66944-106.9056 106.9056a190.464 190.464 0 0 0 262.30784 276.15232l7.08608-6.7584 106.9056-106.9056a61.44 61.44 0 0 1 91.09504 82.24768l-4.21888 4.66944-106.9056 106.9056A313.344 313.344 0 0 1 104.448 476.61056l7.7824-8.11008 106.9056-106.9056a61.44 61.44 0 0 1 86.91712 0z m385.024-27.81184a61.44 61.44 0 0 1 4.21888 82.20672l-4.21888 4.66944-270.336 270.336a61.44 61.44 0 0 1-91.09504-82.20672l4.21888-4.66944 270.336-270.336a61.44 61.44 0 0 1 86.8352 0z m220.65152-221.5936a313.344 313.344 0 0 1 7.7824 435.07712l-7.7824 8.11008-106.9056 106.9056a61.44 61.44 0 0 1-91.09504-82.24768l4.21888-4.66944 106.9056-106.9056a190.464 190.464 0 0 0-262.30784-276.15232l-7.08608 6.7584-106.9056 106.9056a61.44 61.44 0 0 1-91.09504-82.24768l4.21888-4.66944 106.9056-106.9056a313.344 313.344 0 0 1 443.1872 0z" fill="#ffffff" p-id="4438"></path></svg>
                        相关新闻
                      </span>
                    </div>
                    <div class="options">
                    <div class="item" :style="answers[index][i] ? `background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };` : ''" v-for="(info, i) in item.options" :key="info" @click="handleOption(i)"><span v-if="item.type !== 'judge'">{{ String.fromCharCode(65 + i) }}.</span>{{ info }}</div>
                    </div>
                    <div class="ai_result_box" v-show="yhSelect != null">
                        <div class="ai_result">
                            <div class="ai_result_xf ai_result_item">
                                <img class="ai_img" src="https://yunyingcdn.thecover.cn/au_5fc6f0241061d79c680672e3/20240525/AB7DA876-2A6C-D2AC-C5F2-624075183EE5.png" alt="">
                                <p class="ai_select"><span>小山小水选{{String.fromCharCode(65 + aiSelect)}}</span></p>
                            </div>
                            <div class="ai_result_yh ai_result_item">
                                <img class="yh_img" :src="activityData.characterImage || require('@/assets/images/contestanswers/a_user.png')" alt="">
                                <p class="yh_select"><span>我选{{String.fromCharCode(65 + yhSelect)}}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      <div class="btn">
        <button :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" @click="handleNextPage" v-if="(list[index].answer || (index + 1) < list.length) && !isSubmit">确定</button>

        <!-- <button :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" @click="handlePrevPage" v-if="!(list[index].answer && list[index].answer.length) && index">上一题</button>
        <button :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" @click="handleNextPage" v-if="(list[index].answer || (index + 1) < list.length) && !isSubmit">下一题</button> -->
        <!-- <button :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" @click="handleSubmit" v-if="(!list[index].answer && (index + 1) === list.length) || isSubmit">提交</button> -->
      </div>
    </div>
    <div class="result" v-if="list.length" v-show="result" >
      <img src="@/assets/images/contestanswers/success.png" class="success" alt="恭喜答对了！" v-if="result === 1">
      <img src="@/assets/images/contestanswers/fail.png" class="success" alt="答错了" v-if="result === 2">
      <div class="result-tip" v-if="result === 2 && list[index].type !== 'judge'">
        <p>正确答案：</p>
        <p class="result-tip-info" v-for="item in list[index].answer" :key="item">{{ String.fromCharCode(65 + item) }}：{{list[index].options[item]}}</p>
      </div>
      <div class="ai-tips">
          <img src="https://yunyingcdn.thecover.cn/au_5fc6f0241061d79c680672e3/20240525/AB7DA876-2A6C-D2AC-C5F2-624075183EE5.png" alt="">
          <div class="ai-msg-box">
              <div v-if="result === 1 && list[index].answer[0] == aiSelect">
                  <p v-if="showTipsIndex == 0">哇，你竟然跟我一样聪明。</p>
                  <p v-if="showTipsIndex == 1">一起答对题目，很开心吧。</p>
                  <p v-if="showTipsIndex == 2">恭喜你呀，我们好聪明哦。</p>
                  <p v-if="showTipsIndex == 3">都答对了，击个掌庆祝一下吧。</p>
                  <p v-if="showTipsIndex == 4">一起答对，我们来个拥抱吧。</p>
              </div>
              <div v-if="result === 2 && list[index].answer[0] == aiSelect">
                  <p v-if="showTipsIndex == 0">错了没关系，下一题加油呀。</p>
                  <p v-if="showTipsIndex == 1">答错了不要气馁，继续加油。</p>
                  <p v-if="showTipsIndex == 2">一道题错了，证明不了什么的。</p>
                  <p v-if="showTipsIndex == 3">好遗憾你答错了，要加油呀。</p>
                  <p v-if="showTipsIndex == 4">答错了不要难过，你是最棒的。</p>
              </div>
              <div v-if="result === 1 && list[index].answer[0] != aiSelect">
                  <p v-if="showTipsIndex == 0">哇，你答对了呢，真棒。</p>
                  <p v-if="showTipsIndex == 1">恭喜你，又答对了一题。</p>
                  <p v-if="showTipsIndex == 2">你可真聪明，又答对了呢。</p>
                  <p v-if="showTipsIndex == 3">你太厉害了，我有点崇拜你了。</p>
                  <p v-if="showTipsIndex == 4">优秀的人类，又被你猜对了哦。</p>
              </div>
              <div v-if="result === 2 && list[index].answer[0] != aiSelect">
                  <p v-if="showTipsIndex == 0">嚯哟，我们都答错了呢。</p>
                  <p v-if="showTipsIndex == 1">好遗憾，我们俩都答错了。</p>
                  <p v-if="showTipsIndex == 2">一起答错，这是什么缘分呀。</p>
                  <p v-if="showTipsIndex == 3">下一题，我们一定要都答对哦。</p>
                  <p v-if="showTipsIndex == 4">你的错，我的错，好像都一样。</p>
              </div>
          </div>
      </div>
      <div class="result-btn">
          <button :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" @click="handleCloseResult" v-if="((index + 1) < list.length)">下一题</button>
          <button :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" @click="handleSubmit" v-if="((index + 1) === list.length)">提交</button>
      </div>
    </div>
    <div class="end" v-if="score !== null">
      <div class="end-ai-tips">
          <div class="ai-tips-box" >

              <p class="ai-title ai-title-win"  v-show="score > lotteryScore && luckDayTotal == 0">
                恭喜您在本轮比赛中战胜了我，分享成功后可获得1次抽奖机会
              </p>
              <p class="ai-title"  v-show="score > lotteryScore && luckDayTotal != 0">恭喜您在本轮比赛中战胜了我，送一句{{activityData.famousPerson || '苏东坡的诗'}}鼓励你一下吧！</p>
              <p class="ai-title"  v-show="score < lotteryScore">输了比赛也不要难过哦，送一句{{activityData.famousPerson || '苏东坡的诗'}}鼓励你一下吧！</p>
              <p class="ai-title"  v-show="score == lotteryScore">哇，我们打平了，也送一句{{activityData.famousPerson || '苏东坡的诗'}}给你哦！</p>
              <p class="ai-info" v-if="score <= lotteryScore || luckDayTotal != 0">{{selectVerse}}</p>
          </div>
      </div>
      <div class="end-title" :style="`color: ${ activityData.themeColor || '#FB7A43' };`">答 题 结 束</div>
      <div class="end-score" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`">
        <p>我的成绩：<span>{{ score }}分</span></p>
        <p class="end-score-xf">小山小水成绩：<span>{{ lotteryScore }}分</span></p>
      </div>
      
      <!-- <div class="action" style="width: 72vw;">
        <div class="rank" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" @click="handleRank">
          <img src="../../../assets/icon/rank.svg" alt="">
          排行榜
        </div>
        <div class="rank" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" @click="handleStudy">
          学习专区
          <img src="../../../assets/icon/home.svg" alt="">
        </div>
      </div> -->
      <div class="action" style="width: 72vw;" v-if="activityData.sharePosterBg || activityData.lotteryUrl">
        <div class="rank" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" @click="handleShare" v-show="!showHandlePirze">
          <img src="../../../assets/icon/share.svg" alt="">
          分享成绩
        </div>
        <div class="rank" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" @click="handlePirze" v-if="score > lotteryScore" v-show="showHandlePirze">
          去抽奖
          <img src="../../../assets/icon/gift.svg" alt="">
        </div>
      </div>
    </div>
    <dialog-component :baseData="baseData"></dialog-component>
    <div class="guide"  v-if="showGuide">
        <div class="guideImg">
            <div class="guide-text-container">
                <p v-for="(line, index) in lines" :key="index" :style="{'animation-delay': (index + 1) * 0.5 + 's'}">{{ line }}</p>
            </div>
        </div>
        <img class="beginBtn" @click="hiddenGuide" src="@/assets/images/contestanswers/begin_btn.png" alt="">
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min";
import "swiper/swiper-bundle.css";
import { mapState, mapActions, mapMutations } from "vuex";
import COVER from "@/utils/COVER";
import LoadingComponent from '@/components/Loading'
import COVERAPP from '../../../utils/COVERAPP';
import DialogComponent from "@/components/Dialog";
import Config from "@/utils/config";

let session = ''
let swiper = ''
let cdint = ''
let isTeam = false  // 是否是团队赛
let teamInfo = {}  // 团队赛信息
let sessionEndTime = ''  // session 结束时间
export default {
  name: 'answer',
  data() {
    return {
      aid: '',
      luckDayTotal: 0,
      showGuide: true,
      answerTotalCount: 0,//当日答题总次数
      answerDayCount: this.activityData.answerDayCount,//当日答题总次数
      lines: ['你好呀，优秀的人类','我是封面机器人小封','我发起了“寻路东坡知识挑 战赛”','你敢接受挑战吗？'],
      list: [],
      time: '',
      index: 0,
      answers: [],
      aiAnswers: [],
      typeText: {
        radio: '单选题',
        check: '多选题',
        judge: '判断题'
      },
      pageLoading: false,
      result: 0,  // 答题结果
      isSubmit: false,
      score: null,
      lotteryScore: 80,
      countdownText: '00:00',
      area: '',
      institution: '',
      pkarea: '',
      pkinstitution: '',
      aiSelect: 0,
      yhSelect: null,
      imageData: null,
      verses: [
          '但愿人长久，千里共婵娟。',
          '人生如梦，一尊还酹江月。',
          '十年生死两茫茫，不思量，自难忘。',
          '江南好，千钟美酒，一曲满庭芳。',
          '归去。也无风雨也无晴。',
          '拣尽寒枝不肯栖，寂寞沙洲冷。',
          '春未老，风细柳斜斜。',
          '试上超然台上看，半壕春水一城花。',
          '小舟从此逝，江海寄余生。',
          '枝上柳绵吹又少，天涯何处无芳草。',
          '殷勤昨夜三更雨，又得浮生一日凉。',
          '欲把西湖比西子，淡妆浓抹总相宜。',
          '梨花淡白柳深青，柳絮飞时花满城。',
          '惆怅东栏一株雪，人生看得几清明。',
          '长江绕郭知鱼美，好竹连山觉笋香。',
          '东风袅袅泛崇光，香雾空濛月转廊。',
          '只恐夜深花睡去，故烧高烛照红妆。',
          '不识庐山真面目，只缘身在此山中。',
          '空余鲁叟乘桴意，粗识轩辕奏乐声。',
          '人有悲欢离合，月有阴晴圆缺，此事古难全。',
          '明月几时有，把酒问青天。',
          '我欲乘风归去，又恐琼楼玉宇，高处不胜寒。',
          '莫使匆匆云雨散，今夜里，月婵娟。',
          '推手从归去，无泪与君倾。',
          '犯其至难而图其至远。',
          '竹外桃花三两枝，春江水暖鸭先知。',
          '日啖荔枝三百颗，不辞长作岭南人。',
          '江山如画，一时多少豪杰。',
          '明月如霜，好风如水，清景无限。',
      ],
      selectVerse: '',
      showTipsIndex: 0,
      showHandlePirze: false,
      match: 0,
      isViewNews: true,
    }
  },
  props: ["activityData"],
  computed: {
    ...mapState(["dialogData", "userinfo"]),
  },
  components: {
    LoadingComponent,
    DialogComponent,
  },
  created() {
    session = "";
    this.aid = this.$route.query.id || "";
    this.match = +this.$route.query.match || 0;
    isTeam = this.$route.query.isTeam || "";
    const area = localStorage.getItem('answer_area_' + this.aid) || null;
    const institution = localStorage.getItem('answer_institution_' + this.aid) || null;
    this.area = area;
    this.institution = institution;
    // 获取引导语
    if (this.activityData && this.activityData.guideText) {
        this.lines = this.activityData.guideText.split(/[\n\r|↵]/)
    }
    // 获取诗句
    if (this.activityData && this.activityData.poems) {
        this.verses = this.activityData.poems.split(/[\n\r|↵]/)
    }
    var that = this
    document.addEventListener('visibilitychange', function() { 
      if (!document.hidden) {
        that.handleTimeUpdate();
      }
    });

    // 查看相关新闻计算
    if (this.activityData.isViewNoneNews || !COVERAPP.Attribute.isApp()) {
      this.isViewNews = false;
    }
  },
  mounted() {
    this.getLotteryQuerycount();
    COVER.yunTrack(this.aid, "load");
  },
  beforeDestroy() {
    clearInterval(cdint);
  },
  methods: {
    ...mapMutations(["setToastData", "setDialogData"]),
    ...mapActions(["setDialogDataAsync"]),
    getAnswerUserCount(score) {
      var that = this
       COVER.$post("/answer/user/count", {
        aid: this.aid,
        match: this.match,
        userinfo: this.userinfo,
      }).then((res) => {
        if (res.errno == 0) {
          this.answerTotalCount = res.data.dayCount
          this.score = score;
          return;
        }
        
        this.setToastData({
          text: res.errmsg || "网络错误~",
        });
      }).catch(err => {
        this.setToastData({
          text: "网络错误~",
        });
      });
    },
    getLotteryQuerycount() {
      var that = this
       COVER.$post("/lottery/query/count", {
        aid: this.aid,
        match: this.match,
        userinfo: this.userinfo,
      }).then((res) => {
        if (res.errno == 0) {
          this.luckDayTotal = res.data.luckDayTotal
          return;
        } else {
          this.luckDayTotal = 1
          return;
        }
        
        this.setToastData({
          text: res.errmsg || "网络错误~",
        });
      }).catch(err => {
        this.setToastData({
          text: "网络错误~",
        });
      });
    },
    getSubject() {
      this.pageLoading = true;
      COVER.$post("/answer/subject?match=" + this.match, {
        aid: this.aid,
        userinfo: this.userinfo,
      }).then((res) => {
        this.pageLoading = false;
        if (res.errno === 0) {
          const list = res.data.list || [];
          session = res.data.session;
          const times = res.data.times;
          this.time = times;
          sessionEndTime = new Date().getTime() + (times * 1000);
          this.list = list;
          list.forEach(item => {
            this.answers.push([]);
            this.aiAnswers.push(item.answer[0])
          });
          this.$nextTick(() => {
            this.slide();
            this.countdown();
          })
          console.log('this.aiAnswers:::',this.aiAnswers)
          this.aiAnswers = this.getRandomSelect(this.aiAnswers,2)
          this.aiSelect = this.aiAnswers[0]
          this.showGuide = false
          const versesIndex = Math.floor(Math.random()*this.verses.length)
          this.selectVerse = this.verses[versesIndex]
          return;
        }

        this.setToastData({
          text: res.errmsg ||  "网络错误~",
        });
      }).catch(err => {
        console.log(err);
        this.setToastData({
          text: "网络错误~",
        });
      });
    },
    getRandomSelect(arr,num){
        let randomValue = null;
        while (num > 0) {
            let random = Math.floor(Math.random()*arr.length)
            if (random != randomValue) {
                arr[random] = arr[random] ? arr[random]-1 : arr[random]+1
                randomValue = random
            }
            num--
        }
        return arr
    },
    hiddenGuide(){
        this.getSubject();
    },
    // 获取团队
    getTeam() {
      COVER.$post('/answer/team/pkname', {
        aid: this.aid,
        userinfo: this.userinfo,
        teamname: this.area + this.institution,
      }).then(res => {
        if (res.errno === 0) {
          this.pkarea = res.data.area;
          this.pkinstitution = res.data.institution;
          teamInfo = res.data || {};
        }
      });
    },
    slide() {
      const _this = this;
      swiper = new Swiper('.swiper', {
        autoHeight: true,
        on: {
          slideChange(e) {
            _this.index = e.activeIndex;
          },
        },
      })
    },
    handlePrevPage() {
      swiper.slidePrev();
    },
    handleNextPage() {
      const list = this.list;
      const index = this.index;
      const answers = this.answers;
      // 如果有返回答案，需判断是否有作答
      const asinfo = answers[index] || [];
      const option = [];
      asinfo.forEach((item, index) => {
        if (item) {
          option.push(index);
        }
      });
      if (list[index].answer && !option.length) {
        this.setToastData({
          text: "请先选择答案~",
        });
        return;
      }

      // 如果有返回答案，需提示
      if (list[index].answer) {
        if (list[index].answer.sort().join(',') === option.sort().join(',')) {
          this.result = 1;
          return;
        }

        this.result = 2;
        return;
      }

      swiper.slideNext();
    },
    handleOption(i) {
      const index = this.index;
      const list = this.list;
      let answer = this.answers[index];

      if (list[index].type !== 'check') {
        answer = [];
      }
      answer[i] = !answer[i];
      
      this.yhSelect = i
      this.aiSelect = this.aiAnswers[index]
      this.$set(this.answers, index, answer);
    },
    handleTimeUpdate() {
      const _this = this;
      const nowTimes = new Date().getTime();
      
      const times = Math.floor((sessionEndTime - nowTimes) / 1000);
      this.time = times;
      this.countdown();
      if (times === 0) {
        this.submit();
      }
      if (times < 0 && !this.showGuide && this.score == null) {
        this.time = 0;
        clearInterval(cdint);
        this.countdownText = '00:00';
        this.setDialogDataAsync({
          message: "本次答题因超时已中断，请重新开始答题吧。",
          btns: [
            {
              text: "取消",
              className: "close-btn",
            },
            {
              text: "确定",
              className: "share-btn",
              callback() {
                _this.$router.back();
              },
            },
          ],
        });
        return;
      }
    },
    handleSubmit() {
      const _this = this;
      this.result = false;
      const { none } = this.answerCount();
      this.setDialogDataAsync({
        message: (none ? `还有${ none }道题未作答，是否要提交答案？` : (this.activityData.answerSubmitMessage || '是否要提交答案？')),
        btns: [
          {
            text: "取消",
            className: "close-btn",
          },
          {
            text: "确定",
            className: "share-btn",
            callback() {
              _this.submit();
            },
          },
        ],
      });
      /* const is = confirm(none ? `还有${ none }道题未作答，是否要提交答案？` : '是否要提交答案？');
      if (is) {
        this.submit();
      } */
    },
    // 获取答题信息
    answerCount() {
      const answers = this.answers || [];
      const list = this.list || [];
      let answer = {};
      let none = 0;  // 未作答数
      answers.forEach((item, index) => {
        let option = [];
        item.forEach((info, index) => {
          if (info) {
            option.push(index);
          }
        });
        if (!option.length) {
          none++;
        }
        answer[list[index].id] = option;
      });

      return {
        answer,
        none,
      }
    },
    // 提交答案
    submit() {
      const _this = this;
      clearInterval(cdint);
      const { answer } = this.answerCount();
      this.pageLoading = true;
      let info = {};
      const name = localStorage.getItem('answer_name_' + this.aid) || null;
      const phone = localStorage.getItem('answer_phone_' + this.aid) || null;
      const area = localStorage.getItem('answer_area_' + this.aid) || null;
      const institution = localStorage.getItem('answer_institution_' + this.aid) || null;

      if (name) {
        info.name = name;
      }

      if (phone) {
        info.phone = phone;
      }

      if (area) {
        info.area = area;
      }

      if (institution) {
        info.institution = institution;
      }
      
      let param = {
        session,
        answer,
        info,
        aid: this.aid,
        userinfo: this.userinfo,
        match: this.match,
      }
      
      // 若是团队赛，则传团队赛信息
      if (isTeam) {
        param.team = {
          name: this.area + this.institution,
          pid: teamInfo.pid,
        };
      }
      COVER.$post("/answer/submit", param).then((res) => {
        this.pageLoading = false;
        if (res.errno === 2014) {
          this.setToastData({
            text: "已完成答题",
          });
          return;
        }

        if (res.errno === 2012) {
          this.setToastData({
            text: "参与人数已满",
          });
          return;
        }

        if (res.errno === 2013) {
          this.setToastData({
            text: "今日已答题",
          });
          return;
        }

        if (res.errno === 1001) {
          this.setDialogDataAsync({
            message: "本次答题已超时，重新开始答题吧。",
            btns: [
              {
                text: "确定",
                className: "share-btn",
                callback() {
                  _this.$router.back();
                },
              },
            ],
          });
          return;
        }

        if (res.errno !== 0) {
          return alert(res.errmsg || "网络错误~");
        }
        this.score = res.data.score;
        // this.getAnswerUserCount(res.data.score);
      });
    },
    // 关闭结果页
    handleCloseResult() {
      this.result = 0;
      this.$nextTick(() => {
        if ((this.index + 1) === this.list.length) {
          this.isSubmit = true;
          return;
        }
        this.yhSelect = null
        this.showTipsIndex = Math.floor(Math.random()*5)
        this.handleTimeUpdate();
        swiper.slideNext();
      });
    },
    handleStudy() {
      if (this.activityData.studyLink) {
        window.location.href = this.activityData.studyLink;
      }
    },
    // 倒计时
    countdown() {
      let time = this.time;
      if (time >= 0) {
        clearInterval(cdint);
        cdint = setInterval(() => {
          time--;
          if (time < 0) {
            clearInterval(cdint);
            this.submit();
            return;
          }
          const minute = Math.floor(time / 60);
          const second = time - minute * 60;
          this.countdownText = fmnum(minute) + ':' + fmnum(second);
          this.time = time;
        }, 1000);
      }

      function fmnum(n) {
        if (n < 10) {
          return '0' + n;
        }
        
        return n;
      }
    },
    handleRank() {
        if (this.activityData.rankLink) {
            window.location.replace(this.activityData.rankLink);
        } else {
            this.$router.replace('rank?id=' + this.aid);
        }
    },
    toRgba(c) {
      if (!c) {
        return;
      }
      return `linear-gradient(45deg, ${ COVER.hexToRgba(c, 0.7) }, ${ COVER.hexToRgba(c) })`;
    },
    handleShare() {
      COVER.yunTrack(this.aid, "click", {
        label: '分享成绩',
        match: this.match,
        score: this.score,
      });
      const _this = this;
      let nickname = this.userinfo.nickname;
      if (COVERAPP.Attribute.isIOS()) {
        if (COVERAPP.Attribute.appVersion().split('.').join('') >= 450) {
          try {
            nickname = decodeURIComponent(escape(window.atob(nickname)))
          }
          catch(e) {}
        }
      }
      nickname = nickname.replace(/^(.{1}).*(.{1})$/, '$1**$2');
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = this.activityData.sharePosterBg;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        ctx.font = "bold 120px 黑体";
        ctx.textAlign="center";
        ctx.fillStyle=_this.activityData.shareTextColor || "#A05050";
        ctx.fillText(_this.score || 0, 640, 1280);
        ctx.font = "bold 48px 黑体";
        ctx.textAlign="center";
        ctx.fillStyle=_this.activityData.shareTextColor || "#050708";
        ctx.fillText(nickname, 540, 1110);
        
        let shareTips = _this.score == _this.lotteryScore ? '本轮比赛'+nickname+'与小山小水打成平局哦' : _this.score > _this.lotteryScore ? '恭喜'+nickname+'本轮比赛战胜小山小水' : '很遗憾'+nickname+'本轮比赛挑战失败'

        let beginX = (img.width - ctx.measureText(shareTips).width)*0.5
        let endX = (img.width - ctx.measureText(shareTips).width)*0.5 + ctx.measureText(shareTips).width
        ctx.moveTo(beginX,1430);
        ctx.lineTo(endX,1430);
        ctx.lineWidth=15;
        ctx.strokeStyle="#C29A90";
        ctx.stroke();

        ctx.font = "bold 48px 黑体";
        ctx.textAlign="center";
        ctx.fillStyle=_this.activityData.shareTextColor || "#050708";
        ctx.fillText(shareTips, 540, 1430);

        const imageData = canvas.toDataURL();
        COVERAPP.Method.shareImage({
          image: imageData.split(';base64,')[1],
          title: _this.activityData.title,
          desc: _this.activityData.title,
          callback(res) {
            COVER.yunTrack(_this.aid, "share", {
              label: '分享海报',
              match: _this.match,
              score: _this.score,
            });
            if (_this.score > _this.lotteryScore) {
              _this.showHandlePirze = true;
            }
          },
        });
      }
    },
    handlePirze() {
      COVER.yunTrack(this.aid, "click", {
        label: '去抽奖',
        match: this.match,
        score: this.score,
      });
      this.showHandlePirze = false
      window.location.replace(this.activityData.lotteryUrl);
    },
    handleViewNews(info) {
      COVER.yunTrack(this.aid, "click", {
        label: '相关新闻',
        match: this.match,
        ...info,
      });
      if (COVERAPP.Attribute.isApp()) {
        window.location.href = `${ Config.APP_SCHEME_URL }/news?id=${ info.news_id }&flag=1`
      }
    },
  },
}
</script>

<style lang="less" scoped>
.aianswer-wrapper {
    height: 100%;
    overflow-y: auto;
}
.guide {
    width: 100%;
    min-height: 100vh;
    padding-left: 14.35vw;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 25vw;
    .guideImg {
        width: 79.167vw;
        height: 144.444vw;
        background: url('https://yunyingcdn.thecover.cn/au_5fc6f0241061d79c680672e3/20240524/AB5152D6-0271-8EE6-8AED-CD3E4FB9E711.png');
        background-size: 100% 100%;
        position: relative;
        .guide-text-container {
            box-sizing: border-box;
            position: absolute;
            top: 14vw;
            left: 7vw;
            right: 17vw;
            p {
                opacity: 0;
                animation-name: fadeIn;
                animation-duration: 2s;
                animation-fill-mode: forwards;
                color: #000;
                font-size: 4.444vw;
                margin-bottom: 6.48vw;
            }
        }

        @keyframes fadeIn {
            from {
                opacity: 0;
                transform: translateY(20px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
    }
    .beginBtn{
        width: 71.296vw;
        position: absolute;
        bottom: 8vw;
    }
}

.top {
  display: flex;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  top: 7vw;
  left: 0;
  padding: 0 5.5vw;
  box-sizing: border-box;
  z-index: 5;
  .item {
    background: rgba(#302924, .3);
    color: white;
    font-size: 5.2vw;
    padding: 2vw 3vw;
    border-radius: 2vw;
  }
}
.title {
  font-size: 4.8vw;
  color: #333;
  line-height: 1.5em;
  margin-bottom: 6.5vw;
  span {
    font-size: 2.8vw;
    line-height: 3.6vw;
    padding: 1vw 1.5vw;
    box-sizing: border-box;
    border-radius: 2px;
    color: white;
    background: #1890FF;
    margin: 0.6vw 0 0 1vw;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    // width: 15vw;
    svg {
      width: 3.0vw;
      height: 3.0vw;
      margin-right: 0.5vw;
    }
  }
}
.options {
  display: flex;
  flex-direction: column;
  .item {
    width: 80%;
    display: flex;
    border-radius: 2vw;
    font-size: 4vw;
    font-weight: bold;
    justify-content: center;
    box-shadow: 0 1vw 2vw rgba(#000, .3);
    padding: 2vw 3vw;
    box-sizing: border-box;
    line-height: 1.6em;
    margin: 0 auto 4vw auto;
    background: #ABAAAA;
    span {
      margin-right: 2vw;
    }
  }
}
.ai_result_box {
    // position: absolute;
    // bottom: 20.27vw;
    // left: 0;
    padding: 0 4%;
    width: 100%;
    box-sizing: border-box;
    .ai_result{
        display: flex;
        justify-content: space-between;
        margin-top: 21vw;
        .ai_result_item {
            position: relative;
            font-size: 3.88vw;
            min-height: 57.22vw;
            color: white;
            text-align: center;
            span {
                margin-top: 2.5vw;
                display: inline-block;
            }
        }
        .ai_result_xf {
            width: 28.98vw;
            .ai_img {
                width: 28.98vw;
                position: absolute;
                bottom: 0;
                left: 0;
            }
            .ai_select {
                width: 25vw;
                height: 11.76vw;
                background: url('../../../assets/images/contestanswers/a_xf_msg.png') no-repeat;
                background-size: cover;
                position: absolute;
                top: 1vw;
                left: 9.25vw;
            }
        }
        .ai_result_yh {
            width: 34.54vw;
            .yh_img {
                width: 34.54vw;
                position: absolute;
                bottom: 0;
                left: 0;
            }
            .yh_select {
                width: 21.2vw;
                height: 11.76vw;
                background: url('../../../assets/images/contestanswers/a_user_msg.png') no-repeat;
                background-size: cover;
                position: absolute;
                top: -5vw;
                left: -10vw;
            }
        }
    }
}
.btn {
  display: flex;
  position: fixed;
  bottom: 5vw;
  width: 100%;
  box-sizing: border-box;
  left: 0;
  padding: 0 10%;
  z-index: 5;
  button {
    width: 100%;
    display: flex;
    border-radius: 2vw;
    font-size: 4vw;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1vw 2vw rgba(#000, .3);
    padding: 2vw 3vw;
    box-sizing: border-box;
    line-height: 1.6em;
    color: white;
    outline: 0;
    border: 0;
    margin: 0 3vw;
  }
}
.swiper {
  height: 100%;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  .swiper-slide {
    padding: 55vw 5.5vw 20vw 5.5vw;
    box-sizing: border-box;
    height: 100vh;
    overflow: scroll;
  }
}
.result {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 6;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background: rgba(#000, .7);
  overflow: scroll;
  img {
    width: 40%;
  }
  .result-tip {
    color: white;
    font-size: 3.8vw;
    margin-top: 6.56vh;
    max-height: 50vh;
    // overflow: scroll;
    padding: 0 5vw;
    box-sizing: border-box;
    text-align: center;
    .result-tip-info {
        font-size: 4.629vw;
        font-weight: bold;
        margin-top: 2.77vw;
    }
  }
  .ai-tips {
      display: flex;
      margin-top: 18.7vw;
      img {
          width: 15.56vw;
          height: 23.796vw;
      }
      .ai-msg-box {
          width: 54.53vw;
          height: 17.037vw;
          background: url('../../../assets/images/contestanswers/ai_tips_msg.png');
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          p{
              font-size: 3.88vw;
              color: black;
              margin-left: 3vw;
          }
      }
  }
  .result-btn {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      padding: 0 10%;
      margin-top: 10.648vw;
      button {
        width: 100%;
        display: flex;
        border-radius: 2vw;
        font-size: 4vw;
        font-weight: bold;
        align-items: center;
        justify-content: center;
        box-shadow: 0 1vw 2vw rgba(#000, .3);
        padding: 2vw 3vw;
        box-sizing: border-box;
        line-height: 1.6em;
        color: white;
        outline: 0;
        border: 0;
        margin: 0 3vw;
    }
  }
  
}
.end {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 6;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background: rgba(#000, .7);
  .end-ai-tips {
      width: 90.833vw;
      height: 49.814vw;
      background: url('https://yunyingcdn.thecover.cn/au_5fc6f0241061d79c680672e3/20240524/AB4F3206-E69E-C0D1-CC9D-5EBC914B17A3.png');
      background-size: 100% 100%;
      margin-bottom: 17.59vw;
      font-size: 3.7vw;
      color: #37332e;
      position: relative;
      .ai-tips-box {
          position: absolute;
          top: 15vw;
          left: 29.26vw;
          right: 10vw;
          .ai-title-win {
            font-size: 5vw;
            padding: 0 3.2vw;
            line-height: 8.70vw;
            font-weight: bold;
            margin-top: 1vw;
          }
          .ai-info {
              font-size: 5vw;
              font-weight: bold;
              margin-top: 7.129vw;
          }
      }
  }
  .end-title {
    font-size: 8vw;
    font-weight: bold;
    margin-bottom: 7.5vw;
  }
  .end-score {
    width: 72vw;
    margin: 0 auto;
    font-size: 7vw;
    font-weight: bold;
    text-align: center;
    // display: flex;
    // height: 28vw;
    justify-content: center;
    align-items: center;
    border-radius: 3vw;
    margin-bottom: 7.5vw;
    padding: 3vw 0;
    p {
      line-height: 18.51vw;
      display: inline-block;
      
    }
    .end-score-xf {
      border-top: 1px solid rgb(141, 70, 52);
    }
  }
}
.answer-option-img {
  width: 100%;
} 
.team {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  color: white;
  font-size: 4.4vw;
  margin-top: 22vw;
  position: fixed;
  z-index: 5;
  .team-left {
    background: url('../../../assets/images/contestanswers/t_bg_l.png');
    background-size: 100% 100%;
    width: 51%;
    height: 29.16vw;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8vw 0 3vw;
    box-sizing: border-box;
  }
  img {
    position: absolute;
    width: 8.4vw;
    height: 8.4vw;
    margin-left: 45.8vw;
  }
  .team-right {
    background: url('../../../assets/images/contestanswers/t_bg_r.png');
    background-size: 100% 100%;
    width: 51%;
    height: 29.16vw;
    margin-left: -4vw;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 3vw 0 8vw;
    box-sizing: border-box;
  }

  
}
.sharePoster {
    position: fixed;
    width: 80vw;
    left: 10vw;
    top: 0;
}
</style>